/* ==========================================================================
   COLORBOX SLIDER JS - Shared Slider Logic
   Version: 1.0
   ========================================================================== */

/* ==========================================================================
   Hero Slider
   ========================================================================== */
window.ColorboxHeroSlider = function(sectionId, options) {
  var section = document.querySelector('.hero-slider-' + sectionId);
  if (!section) return;

  var wrapper = section.querySelector('.hero-slider__slides');
  var slides = section.querySelectorAll('.hero-slider__slide');
  var prevBtn = section.querySelector('.hero-slider__nav--prev');
  var nextBtn = section.querySelector('.hero-slider__nav--next');
  var dots = section.querySelectorAll('.hero-slider__dot');

  var currentIndex = 0;
  var autoplayInterval;
  var autoplay = options.autoplay !== false;
  var autoplaySpeed = options.autoplaySpeed || 5000;
  var slideCount = slides.length;

  function goToSlide(index) {
    if (index < 0) index = slideCount - 1;
    if (index >= slideCount) index = 0;
    currentIndex = index;
    wrapper.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    dots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === currentIndex);
    });
  }

  function nextSlide() { goToSlide(currentIndex + 1); }
  function prevSlide() { goToSlide(currentIndex - 1); }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() {
    stopAutoplay(); prevSlide(); setTimeout(startAutoplay, autoplaySpeed);
  });

  if (nextBtn) nextBtn.addEventListener('click', function() {
    stopAutoplay(); nextSlide(); setTimeout(startAutoplay, autoplaySpeed);
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      stopAutoplay();
      goToSlide(parseInt(dot.dataset.slide));
      setTimeout(startAutoplay, autoplaySpeed);
    });
  });

  var touchStartX = 0;
  section.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  section.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      stopAutoplay();
      if (diff > 0) nextSlide();
      else prevSlide();
      setTimeout(startAutoplay, autoplaySpeed);
    }
  }, { passive: true });

  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);
  startAutoplay();
};

/* ==========================================================================
   Brands Slider
   ========================================================================== */
window.ColorboxBrandsSlider = function(sectionId, options) {
  var section = document.querySelector('.brands-slider-' + sectionId);
  if (!section) return;

  var container = section.querySelector('[data-slider-container]');
  var slides = container.querySelectorAll('.brands-slider__slide');
  var prevBtn = section.querySelector('[data-slider-prev]');
  var nextBtn = section.querySelector('[data-slider-next]');

  var gap = options.gap || 20;
  var currentIndex = 0;

  function getVisibleSlides() {
    if (window.innerWidth <= 749) return 2;
    if (window.innerWidth <= 989) return 3;
    return 5;
  }

  function getMaxIndex() {
    return Math.max(0, slides.length - getVisibleSlides());
  }

  function updateSlider() {
    var visibleSlides = getVisibleSlides();
    var slideWidth = (container.offsetWidth - (gap * (visibleSlides - 1))) / visibleSlides;
    var offset = currentIndex * (slideWidth + gap);
    container.style.transform = 'translateX(-' + offset + 'px)';
  }

  function updateNavButtons() {
    if (slides.length <= getVisibleSlides()) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'flex';
    }
  }

  function goToSlide(index) {
    var maxIndex = getMaxIndex();
    if (index < 0) index = 0;
    if (index > maxIndex) index = maxIndex;
    currentIndex = index;
    updateSlider();
  }

  prevBtn.addEventListener('click', function() { goToSlide(currentIndex - 1); });
  nextBtn.addEventListener('click', function() { goToSlide(currentIndex + 1); });

  var touchStartX = 0;
  container.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  container.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) goToSlide(currentIndex + 1);
      else goToSlide(currentIndex - 1);
    }
  }, { passive: true });

  window.addEventListener('resize', function() {
    currentIndex = Math.min(currentIndex, getMaxIndex());
    updateSlider();
    updateNavButtons();
  });

  updateNavButtons();
  updateSlider();
};

/* ==========================================================================
   Artists Slider
   ========================================================================== */
window.ColorboxArtistsSlider = function(sectionId, options) {
  var section = document.querySelector('.artists-slider-' + sectionId);
  if (!section) return;

  var wrapper = section.querySelector('[data-slider-wrapper]');
  var slides = section.querySelectorAll('.artists-slider__slide');
  var prevBtn = section.querySelector('[data-slider-prev]');
  var nextBtn = section.querySelector('[data-slider-next]');
  var dots = section.querySelectorAll('.artists-slider__dot');

  var currentIndex = 0;
  var autoplayInterval;
  var autoplay = options.autoplay !== false;
  var autoplaySpeed = (options.autoplaySpeed || 5) * 1000;
  var slideCount = slides.length;

  function goToSlide(index) {
    if (index < 0) index = slideCount - 1;
    if (index >= slideCount) index = 0;
    currentIndex = index;
    slides.forEach(function(slide, i) {
      slide.classList.toggle('active', i === currentIndex);
    });
    wrapper.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    dots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === currentIndex);
    });
  }

  function nextSlide() { goToSlide(currentIndex + 1); }
  function prevSlide() { goToSlide(currentIndex - 1); }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() {
    stopAutoplay(); prevSlide(); startAutoplay();
  });

  if (nextBtn) nextBtn.addEventListener('click', function() {
    stopAutoplay(); nextSlide(); startAutoplay();
  });

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      stopAutoplay(); goToSlide(i); startAutoplay();
    });
  });

  var touchStartX = 0;
  wrapper.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoplay();
  }, { passive: true });

  wrapper.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextSlide();
      else prevSlide();
    }
    startAutoplay();
  }, { passive: true });

  if (slides.length > 0) slides[0].classList.add('active');
  startAutoplay();
};

/* ==========================================================================
   Tab System
   ========================================================================== */
window.ColorboxTabs = function(container) {
  if (!container) return;

  var tabs = container.querySelectorAll('[data-tab]');
  var contents = container.querySelectorAll('[data-tab-content]');
  var viewAllLinks = container.querySelectorAll('[data-tab-index]');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var tabIndex = this.dataset.tab;
      
      tabs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      
      contents.forEach(function(c) {
        c.classList.toggle('active', c.dataset.tabContent === tabIndex);
      });

      viewAllLinks.forEach(function(link) {
        link.classList.toggle('active', link.dataset.tabIndex === tabIndex);
      });
    });
  });
};

/* ==========================================================================
   Lazy Load Images
   ========================================================================== */
window.ColorboxLazyLoad = function() {
  var lazyImages = document.querySelectorAll('.cb-lazy-image, .lazy-image');
  
  if ('IntersectionObserver' in window) {
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          var src = img.dataset.src;
          if (src) {
            img.src = src;
            img.onload = function() { img.classList.add('loaded'); };
            img.onerror = function() { img.classList.add('loaded'); };
          }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    
    lazyImages.forEach(function(img) { imageObserver.observe(img); });
  } else {
    lazyImages.forEach(function(img) {
      var src = img.dataset.src;
      if (src) {
        img.src = src;
        img.onload = function() { img.classList.add('loaded'); };
      }
    });
  }
};

/* ==========================================================================
   Filter System (Brands Page)
   ========================================================================== */
window.ColorboxFilter = function(container) {
  if (!container) return;

  var filterBtns = container.querySelectorAll('.filter-btn');
  var items = container.querySelectorAll('[data-letter]');

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var letter = this.dataset.letter;
      
      filterBtns.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      
      items.forEach(function(item) {
        if (letter === 'all' || item.dataset.letter === letter) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    });
  });

  var filterContainer = container.querySelector('.brands-filter');
  var leftArrow = container.querySelector('.filter-arrow--left');
  var rightArrow = container.querySelector('.filter-arrow--right');

  if (filterContainer && leftArrow && rightArrow) {
    function updateArrows() {
      var scrollLeft = filterContainer.scrollLeft;
      var maxScroll = filterContainer.scrollWidth - filterContainer.clientWidth;
      leftArrow.classList.toggle('hidden', scrollLeft <= 2);
      rightArrow.classList.toggle('hidden', scrollLeft >= maxScroll - 2);
    }

    leftArrow.addEventListener('click', function() {
      filterContainer.scrollBy({ left: -150, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', function() {
      filterContainer.scrollBy({ left: 150, behavior: 'smooth' });
    });

    filterContainer.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 100);
  }
};

document.addEventListener('DOMContentLoaded', window.ColorboxLazyLoad);
